<div (click)="toggleDataPanel()" class="analysis-heading">
  <!-- Analysis Label & Status -->
  <div class="analysis-info">
    <div *ngIf="editLabel === null" class="analysis-title">
      <fw-icon *ngIf="jobState$ | async as jobState" data-id="analyses-tab-label" class="job-state-icon" [color]="
          jobState === 'complete' ? 'green' :
          jobState === 'cancelled' || jobState === 'failed' ? 'red' :
          jobState === 'pending' ? 'slate' : 'primary'
        ">
        <ng-container [ngSwitch]="jobState">
          <ng-container *ngSwitchCase="'complete'">done-check-tracked</ng-container>
          <ng-container *ngSwitchCase="'cancelled'">minus</ng-container>
          <ng-container *ngSwitchCase="'pending'">pause</ng-container>
          <ng-container *ngSwitchCase="'running'">setting-gear</ng-container>
          <ng-container *ngSwitchCase="'failed'">warning</ng-container>
        </ng-container>
      </fw-icon>
      <span class="analysis-label">{{ analysis.label }}</span>
      <button mat-icon-button
        data-id="analyses-tab-edit"
        *ngIf="canEditAnalysis"
        (click)="editLabel = analysis.label; $event.stopPropagation()"
        [disableRipple]="true"
        class="edit-label-button">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
    <div *ngIf="editLabel !== null" (click)="$event.stopPropagation()" class="analysis-edit-section">
      <mat-form-field class="edit-label-input">
        <input type="text" matInput [(ngModel)]="editLabel" required>
      </mat-form-field>
      <div class="button-group">
        <button
          test-id="save-button"
          class="xs"
          mat-icon-button matTooltip="{{ 'common.actions.save' | translate }}"
          (click)="saveAnalysisLabel()">
          <mat-icon class="xs">done</mat-icon>
        </button>
        <button
          test-id="cancel-button"
          class="xs"
          mat-icon-button matTooltip="{{ 'common.actions.cancel' | translate }}"
          (click)="editLabel = null; $event.stopPropagation()">
          <mat-icon class="xs">clear</mat-icon>
        </button>
      </div>
    </div>
    <!-- Gear Name -->
    <div *ngIf="analysis.gear_info" data-id="analyses-tab-gear">
      <span class="text-muted">{{ 'common.labels.gear' | translate }}:</span> {{ analysis.gear_info.name }}
    </div>
    <div *ngIf="jobPrioritization && job$ | async as job" data-id="analyses-tab-job-priority">
      <span class="text-muted">{{ 'common.labels.priority' | translate }}:</span> {{ job.priority ? ('jobs.priority.'+job.priority | translate) : '' }}
    </div>
    <div *ngIf="job$ | async as job; else analysisCreatedDate" data-id="analyses-tab-created">
      <span class="text-muted">{{ 'common.labels.created' | translate }}:</span> {{ job.created | date:'yyyy/MM/dd HH:mm' }}
    </div>
    <ng-template #analysisCreatedDate>
      <div data-id="analyses-tab-created"><span class="text-muted">{{ 'common.labels.created' | translate }}:</span> {{ analysis.created | date:'yyyy/MM/dd HH:mm'}}</div>
    </ng-template>
  </div>
  <div class="analysis-level">{{ analysis.parent.type }}</div>
  <!-- Type -->
  <div class="label label-default label-sm">{{ 'common.labels.analysis' | translate }}</div>
  <!-- Task Menu -->
  <div *ngIf="canDeleteAnalysis || canDownloadFiles" (click)="$event.stopPropagation()" style="margin-left:5px">
    <fw-icon data-id="analyses-tab-options" [matMenuTriggerFor]="taskMenu" class="task-menu-btn menu-icon" size="small" color="slate">menu-vertical</fw-icon>
    <mat-menu [attr.data-id]="'analyses-tab-optionlist'" #taskMenu="matMenu">
      <button mat-menu-item (click)="deleteAnalysis()" *ngIf="canDeleteAnalysis" [disabled]="(jobState$ | async) === 'pending' || (jobState$ | async) === 'running'">
        <mat-icon>delete</mat-icon>
        <span>{{ 'common.actions.delete' | translate }}</span>
      </button>
      <button mat-menu-item (click)="downloadAnalysisFiles()" *ngIf="canDownloadFiles">
        <mat-icon>cloud_download</mat-icon>
        <span>{{ 'analysisResults.actions.downloadFiles' | translate }}</span>
      </button>
      <button mat-menu-item *ngFor="let app of viewerApps$ | async" (click)="viewInApp(app)">{{ 'common.actions.launchIn' | translate | interpolate:app.name }}</button>
    </mat-menu>
  </div>
</div>

<div class="analysis-data" *ngIf="expanded">
  <mat-tab-group mat-stretch-tabs="false" animationDuration="0ms" class="tabs-compact">

    <mat-tab label="{{ 'common.labels.results' | translate }}">
      <!-- Inputs -->
      <table class="legacy-table legacy-table-subtle no-margin-width">
        <thead>
          <th style="width:60%">{{ 'common.labels.inputs' | translate }}</th>
          <th style="width:20%">{{ 'common.labels.type' | translate }}</th>
          <th style="width:10%" class="text-right">{{ 'common.labels.tasks' | translate }}</th>
        </thead>
        <tbody>
          <ng-container *ngIf="analysis.inputs && analysis.inputs.length > 0; else noInputs">
            <tr *ngFor="let file of analysis.inputs" class="fw-tr">
              <td class="analysis-file-name">
                <div>
                  <fw-ellipsis [text]="file.name" test-id="analysis-input-file-name" class="file-name"></fw-ellipsis>
                  <file-version-badge *ngIf="file.version > 1" test-id="analysis-input-file-version"
                    [file]="file" class="version-badge"></file-version-badge>
                </div>
              </td>
              <td>{{ file.type }}</td>
              <td class="text-right">
                <file-actions [file]="file" [container]="$any(getFileParent(file))" [kabobFeatures]="$any(['info', 'download', 'version-history', 'view'])" style="float:right">
                  <fw-icon class="task-menu-btn menu-icon" size="small" color="slate">menu-vertical</fw-icon>
                </file-actions>
              </td>
            </tr>
          </ng-container>
          <ng-template #noInputs>
            <tr class="fw-tr">
              <td colspan="3"><span class="text-muted"><em>{{ 'analysisResults.labels.noInputs' | translate }}</em></span></td>
            </tr>
          </ng-template>
        </tbody>
      </table>
      <!-- Outputs -->
      <table class="legacy-table legacy-table-subtle no-margin-width">
        <thead>
          <th style="width:60%">{{ 'common.labels.outputs' | translate }}</th>
          <th style="width:20%">{{ 'common.labels.type' | translate }}</th>
          <th style="width:10%" class="text-right">{{ 'common.labels.tasks' | translate }}</th>
        </thead>
        <tbody>
          <ng-container *ngIf="analysis.files && analysis.files.length > 0; else missingOutputs">
            <tr class="fw-tr" *ngFor="let file of analysis.files">
              <td class="analysis-file-name">
                <fw-ellipsis [text]="file.name" test-id="analysis-output-file-name" class="file-name"></fw-ellipsis>
                <file-version-badge *ngIf="file.version > 1" test-id="analysis-output-file-version" [file]="file"
                  class="version-badge"></file-version-badge>
              </td>
              <td>{{ file.type }}</td>
              <td class="text-right">
                <file-actions [file]="file" [container]="$any(getFileParent(file))" [kabobFeatures]="$any(['info', 'download', 'version-history', 'view'])" style="float:right">
                  <fw-icon class="task-menu-btn menu-icon" size="small" color="slate">menu-vertical</fw-icon>
                </file-actions>
              </td>
            </tr>
          </ng-container>
          <ng-template #missingOutputs>
            <tr class="fw-tr" *ngIf="jobState$ | async as state; else noOutputs">
              <ng-container *ngIf="state === 'running' || state === 'pending'; else noOutputs">
                <td colspan="3"><span class="text-muted"><em>{{ 'analysisResults.labels.filesProcessingWarning' | translate }}</em></span></td>
              </ng-container>
            </tr>
            <ng-template #noOutputs>
              <td colspan="3"><span class="text-muted"><em>{{ 'analysisResults.labels.noOutputs' | translate }}</em></span></td>
            </ng-template>
          </ng-template>
        </tbody>
      </table>
    </mat-tab>

    <mat-tab label="{{ 'common.labels.notes' | translate }}">
      <container-notes [container]="analysis" [notes]="analysis.notes" (afterSave)="analysis.notes = $event"></container-notes>
    </mat-tab>

    <mat-tab label="{{ 'common.labels.customInformation' | translate }}">
      <info-edit [container]="analysis" [info]="analysis.info" [writable]="canEditAnalysis" (afterSave)="analysis.info = $event" [changeManagerEnabled]="false"></info-edit>
    </mat-tab>

    <mat-tab label="{{ 'analysisResults.labels.gearConfiguration' | translate }}" *ngIf="config$ | async as config">
      <table *ngIf="config && config.length > 0; else emptyConfig" class="legacy-table legacy-table-subtle no-margin-width">
        <tbody>
          <tr *ngFor="let parameter of config" class="fw-tr">
            <td width="260"><strong>{{ parameter.key }}</strong></td>
            <td>{{ parameter.value }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyConfig>
        <div class="blank-state">
          <p>{{ 'analysisResults.labels.noConfigurationOptions' | translate }}</p>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'analysisResults.labels.gearInformation' | translate }}" *ngIf="gear$ | async as gear">
      <table class="legacy-table legacy-table-subtle no-margin-width">
        <tbody>
            <tr>
              <td width="140"><strong>{{ 'common.labels.name' | translate }}</strong></td>
              <td>{{ gear.gear.label }}</td>
            </tr>
            <tr>
              <td width="140"><strong>{{ 'common.labels.version' | translate }}</strong></td>
              <td>{{ gear.gear.version }}</td>
            </tr>
            <tr>
              <td width="140"><strong>{{ 'common.labels.source' | translate }}</strong></td>
              <td><a href="{{ gear.gear.source }}" *ngIf="gear.gear.source" target="_blank">{{ gear.gear.source }}</a></td>
            </tr>
            <tr>
              <td width="140"><strong>{{ 'common.labels.url' | translate }}</strong></td>
              <td><a href="{{ gear.gear.url }}" *ngIf="gear.gear.url" target="_blank">{{ gear.gear.url }}</a></td>
            </tr>
            <tr>
              <td width="140"><strong>{{ 'common.labels.license' | translate }}</strong></td>
              <td>{{ gear.gear.license }}</td>
            </tr>
        </tbody>
      </table>
    </mat-tab>

    <mat-tab label="{{ 'analysisResults.labels.gearLogs' | translate }}" *ngIf="job$ | async as job">
      <ng-template matTabContent>
        <!-- lazy load -->
        <!-- core-api sets job._id, old core sets job.id -->
        <job-log [jobId]="job._id || job.id"></job-log>
      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>
